import type { ReactNode } from 'react';
import { Outlet, useMatches } from 'react-router-dom';
import { Sidebar } from '@/components/organisms/Sidebar';
import { Topbar } from '@/components/organisms/Topbar';
import { Drawer } from '@/components/organisms/Drawer';
import { Toaster } from '@/components/organisms/Toaster';
import { CommandPalette } from '@/components/organisms/CommandPalette';
import { MaintenanceTakeover } from '@/components/organisms/MaintenanceTakeover';
import { DocPreviewModal } from '@/components/organisms/DocPreviewModal';
import { ThemeDensityPanel } from '@/components/organisms/ThemeDensityPanel';
import { InstallPrompt } from '@/components/organisms/InstallPrompt';
import { useLiveNotifications } from '@/hooks/useLiveNotifications';

type Handle = { crumb?: string; fullBleed?: boolean; rail?: () => ReactNode };

export const AppShellLayout = () => {
  useLiveNotifications();
  const matches = useMatches();
  const last = matches[matches.length - 1];
  const handle = (last?.handle ?? {}) as Handle;
  const fullBleed = handle.fullBleed === true;
  const rail = handle.rail?.();
  const crumb = handle.crumb ?? 'Início';

  return (
    <div className="app">
      <a className="skip-link" href="#main-content">Ir para o conteúdo</a>
      <Sidebar />
      <div className="main">
        <Topbar crumb={crumb} />
        <div className="canvas" data-rail={rail ? 'on' : 'off'}>
          <main id="main-content" tabIndex={-1} className={fullBleed ? 'view-host host-bleed' : 'view-host'}>
            <Outlet />
          </main>
          {rail && <aside className="rail">{rail}</aside>}
        </div>
      </div>
      <CommandPalette />
      <Drawer />
      <Toaster />
      <MaintenanceTakeover />
      <DocPreviewModal />
      <ThemeDensityPanel />
      <InstallPrompt />
    </div>
  );
};
